import React, {useEffect, useState} from 'react'
import '../css/youtubecard.css'

const API_KEY = "AIzaSyAoP1-Ga0oEkYRB_nps2dk07jXtqGPJz0o"; // Make sure this is restricted in Google Cloud!
const CHANNEL_ID = "UCijlLKAY2ddkDBGqommWOtg";
const MAX_RESULTS = 10;

const YoutubeCard =() => {
    const [videos, setVideos] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchVideos = async () => {
            try{
                const response = await fetch(
                    `https://www.googleapis.com/youtube/v3/search?key=${API_KEY}&channelId=${CHANNEL_ID}&part=snippet&order=date&maxResults=${MAX_RESULTS}`
                  );
                const data = await response.json();

                if(data.items){
                    setVideos(data.items);
                }else{
                    throw new Error("No Videos Found");
                }
            }catch(error){
                console.error("Error fetching videos: ", error);
                setError("Failed to load videos");
            }
        };
        fetchVideos();
    }, []);

        return (
        <div className='parent-card'>
            {error ? (
                <p>{error}</p>
            ) : (
                videos.map((video) => (
                    <div className='card-border' key={video.id.videoId}>
                        <div className='card'>
                            <a href={`https://www.youtube.com/watch?v=${video.id.videoId}`} target="_blank" rel="noopener noreferrer">
                                <img src={video.snippet.thumbnails.medium.url} alt={video.snippet.title} /> 
                                <figcaption>{video.snippet.title}</figcaption>
                            </a>
                        </div>
                    </div>
                ))
            )}
        </div>
        )

}

export default YoutubeCard
